import * as z from "zod/v4";
import {
  getSelfServeOnboardingStats,
  selfServeOnboardingStatsSchema,
} from "../onboardings/get-self-serve-onboarding-stats";
import { onboardingV2AnalyticsProductInputSchema } from "./analytics-product-id";

export const getOnboardingsV2Stats = {
  name: "getOnboardingsV2Stats" as const,
  input: z.intersection(
    getSelfServeOnboardingStats.input,
    onboardingV2AnalyticsProductInputSchema,
  ),
  output: selfServeOnboardingStatsSchema,
};

export type GetOnboardingsV2StatsInput = z.infer<
  typeof getOnboardingsV2Stats.input
>;
export type GetOnboardingsV2StatsOutput = z.infer<
  typeof getOnboardingsV2Stats.output
>;
